module.exports = __webpack_public_path__ + "static/media/5.0ccbf9c7.mp3";